import type { ThemeComponentType } from '../types';

export const UnstyledButton: ThemeComponentType = {
  styles: theme => ({
    root: {
      color: 'inherit',
      letterSpacing: 'inherit',
      lineHeight: 'normal',
      fontWeight: 'inherit',
      '&:disabled': {
        cursor: 'default',
        color: theme.colors.gray[3],
        backgroundColor: theme.colors.gray[1],
      },
    },
  }),
};
